@use "variables" as *;

.rate {
  font-size: $fontSize-m;
}

.rateCard {
  padding: $spacing-xxs $spacing-s;
  text-align: center;
}

.date {
  font-size: $fontSize-s;
  font-weight: normal;
  text-align: center;
}

.defaultIcon {
  display: flex;
  height: 50px;
  width: 56px;
  margin-left: $spacing-s;
  margin-right: $spacing-s;
  align-items: center;
  justify-content: center;
  border-radius: 16px !important;
}

.rightContainer {
  height: 100%;
  width: 100%;
  margin-top: $spacing-m;
  margin-right: $spacing-s;
}
